export const SOCKET_HOST = process.env.REACT_APP_SOCKET_HOST;
export const DIDI_CES = process.env.REACT_APP_DIDI_CES;
export const CES_CONSIDERED = DIDI_CES.split(',');

export const employmentSituationOpts = [
  { value: '', text: 'Seleccione' },
  { value: '1', text: 'Dependiente' },
  { value: '2', text: 'Independiente' },
  // { value: '3', text: 'Empresa' },
];

export const nationalityOpts = [
  { value: '', text: 'Seleccione' },
  { value: '1', text: 'Chileno(a)' },
  { value: '2', text: 'Extranjero(a)' },
];

export const typeContractOpts = [
  { value: '', text: 'Seleccione' },
  { value: '1', text: 'Indefinido' },
  { value: '2', text: 'A plazo' },
  { value: '3', text: 'A contrata' },
];

export const typeRentOpts = [
  { value: '', text: 'Seleccione' },
  { value: '1', text: 'Fija' },
  { value: '2', text: 'Variable' },
];

export const businessTypeOpt = [
  { value: '', text: 'Seleccione' },
  { value: '1', text: 'Auto Renuévate' },
  { value: '2', text: 'Convencional' },
]

export const initialInsurances = {
  ReparacionesMenores: false,
  DesgravamenPlus: false,
  AutoProtegido: false,
  PerdidaTotal: false,
  Desgravamen: false,
  Cesantia: false,
  RDH: false,
  GPS: false,
};

export const BUSINESS_TYPES = {
  CONVENCIONAL: "2",
  AUTORENUEVATE: "1"
}

export const VEHICLE_TYPES = {
  AUTO: "1",
  MOTO: "5",
  CAMION: "2",
  BUS: "11"
}

export const VEHICLE_TYPES_INT = {
  AUTO: 1,
  MOTO: 5,
  CAMION: 2,
  BUS: 11
}